import React, { Component } from "react";
import styled from "styled-components";
import intercom from "../assets/icons/intercomLogo.png";
import stripe from "../assets/icons/stripeLogo.png";

const Container = styled.div`
  clear: both;
`;

const LogoImage = styled.div`
  background-size:cover;
  background-position:center;
  background-image: url('${props => (props.bg ? props.bg : "")}');
  float:left;
  margin-right:12px;
  box-sizing:border-box;
  border-radius:5px;
  width: 45px;
  height: 45px;
`;

const Title = styled.h2`
  font-family: "Open Sans", sans-serif;
  font-size: 25px !important;
  font-weight: bold !important;
  line-height: 24px !important;
  color: #696969;
  letter-spacing: 0.03px;
  margin-bottom: 0;
`;

const Location = styled.span`
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  color: #696969;
  letter-spacing: 0.94px;
`;

const InfoBlock = styled.div`
  width: 100%;
  padding: 10px;
  font-family: "Open Sans", sans-serif;
  border-radius: 5px;
  font-size: 12px;
  overflow: auto;
`;

const Health = InfoBlock.extend`
  text-align: center;
  color: white;
  background-color: #45eaaf;
  font-weight: 700;
  margin: 20px 0 30px 0;
  text-transform: uppercase;
`;

const SplitBlock = InfoBlock.extend`
  background-color: #f9f9f9;
  margin-bottom: 10px;
`;

const SplitLeftText = styled.span`
  text-transform: uppercase;
  color: #696969;
  font-weight: 600;
`;

const SplitRightText = styled.span`
  text-transform: none;
  color: #696969;
  float: right;
`;

const AppLink = styled.a`
  padding-left:20px;
  background-image: url('${props => props.icon}');
  background-repeat: no-repeat;
  background-size:15px;
  color: ${props => props.textColor} !important;
  float: ${props => (props.float ? props.float : "")};
  font-size:12px;
  text-transform:uppercase;
  text-decoration:none;
  font-weight:600;
  float:left;

  &:last-of-type {
		float:right;
    background-size:13px;
	}
`;

const InfoTable = styled.table`
  width: 100%;
  margin: 20px 0 0 0;
  font-family: "Open Sans", sans-serif;
  color: #696969;

  th {
    text-align: left;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 700;
    padding: 0 0 10px 0;
  }

  td {
    font-weight: 200;
    padding: 3px 0;
    font-weight: 400;
  }

  td:first-of-type {
    padding-left: 20px;
    text-transform: uppercase;
  }

  td:last-of-type {
    float: right;
    font-style: italic;
  }

  tr {
    font-size: 11px;
  }
`;

export default class CustomerInfo extends Component {
  render() {
    console.log("customerinfo props => ", this.props);
    return (
      <Container>
        <LogoImage bg={this.props.logo} />
        <Title>{this.props.title}</Title>
        <Location>San Fransisco, California</Location>
        <Health>Good Health</Health>
        <SplitBlock>
          <SplitLeftText>Status</SplitLeftText>
          <SplitRightText>Active</SplitRightText>
        </SplitBlock>
        <SplitBlock>
          <SplitLeftText>Email</SplitLeftText>
          <SplitRightText>{this.props.customerData.email}</SplitRightText>
        </SplitBlock>
        <InfoBlock style={{ padding: "5px 0" }}>
          <AppLink
            textColor={"#008BF0"}
            href="http://www.google.com"
            icon={intercom}
          >
            Intercom
          </AppLink>
          <AppLink
            textColor={"#636FE8"}
            href="http://www.google.com"
            icon={stripe}
          >
            Stripe
          </AppLink>
        </InfoBlock>
        <InfoTable>
          <tr>
            <th>History</th>
          </tr>
          <tr>
            <td>Signed Up</td>
            <td>July 23, 2013</td>
          </tr>
          <tr>
            <td>Subscribed</td>
            <td>Oct 2, 2015</td>
          </tr>
          <tr>
            <td>Cancelled</td>
            <td>Sept 3, 2017</td>
          </tr>
          <tr>
            <td>Last Seen</td>
            <td>Oct 2, 2017</td>
          </tr>
        </InfoTable>
        <InfoTable>
          <tr>
            <th>Customer Value</th>
          </tr>
          <tr>
            <td>Lifespan</td>
            <td>12 Months</td>
          </tr>
          <tr>
            <td>Provider</td>
            <td>Stripe</td>
          </tr>
          <tr>
            <td>Subscription Plan</td>
            <td>Professional</td>
          </tr>
          <tr>
            <td>MRR</td>
            <td>$1,495</td>
          </tr>
          <tr>
            <td>Last Billing Date</td>
            <td>Oct 2, 2017</td>
          </tr>
          <tr>
            <td>Total Lifetime Value</td>
            <td>$8,848</td>
          </tr>
        </InfoTable>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomerInfo.js